export default __webpack_public_path__ + "img/pin_icons/medical_gas_w.png";